import {
    GETSUBMODULENAMELIST_SUCCESS,
    GETSUBMODULENAMELIST_FAILED,
    RESET_GETSUBMODULENAMELIST,
    LOADING_GETSUBMODULENAMELIST,
    NETWORK_ERROR_GETSUBMODULENAMELIST
} from "../types/index";

import {partnerServices} from "../../config/axios";


const resetGetSubModuleNameListForPartner = () => {
    return { type: RESET_GETSUBMODULENAMELIST };
};

const partnerGetSubModuleNameList = (userData, authToken) => async (dispatch) => {
    dispatch({ type: LOADING_GETSUBMODULENAMELIST });
    await partnerServices
        .post("getSubModuleNameList", userData, { headers: { AuthToken: authToken } })
        .then((res) => {
            switch (res.data.status) {
                case "SUCCESS":
                    dispatch(partnerGetSubModuleNameListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetSubModuleNameListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETSUBMODULENAMELIST,
                payload: err
            });
        });
};

function partnerGetSubModuleNameListsuccess(data) {
    return {
        type: GETSUBMODULENAMELIST_SUCCESS,
        payload: data,
    };
}

function partnerGetSubModuleNameListFailed(data) {
    return {
        type: GETSUBMODULENAMELIST_FAILED,
        payload: data,
    };
}

export { resetGetSubModuleNameListForPartner, partnerGetSubModuleNameList }